import { Button, Descriptions, Form, Input, Skeleton } from 'antd';
import React, { useContext, useState } from 'react';
import ShareContentBar from '../../../app/components/bars/ShareContentBar';
import { CollectionStatus, ICollection } from '../../../app/models/Collection';
import CollectionPodComponent from './CollectionPodComponent';
import CollectionWaybillBarcodeComponent from './CollectionWaybillBarcodeComponent';
import { RootStoreContext } from '../../../app/stores/rootStore';
import moment from 'moment';

interface IProps {
	collection?: ICollection;
	editableComment?: boolean;
}

const CollectionWaybillDescriptionsComponent: React.FC<IProps> = ({
	collection,
	editableComment
}) => {
	const rootContext = useContext(RootStoreContext);

	const { updateComment } = rootContext.collectionStore;
	const [comment, setComment] = useState(collection?.comment ?? '');

	const getCommentComponent = () => {
		const saveChanges = () => {
			updateComment({ collectionId: collection?.id!, comment: comment });
		};
		if (editableComment) {
			return (
				<div>
					<Form.Item label="Comment">
						<Input
							autoComplete="off"
							defaultValue={collection?.comment}
							onChange={(it) =>
								setComment(it.currentTarget.value)
							}
						/>
						<Button onClick={saveChanges}>Save Comment</Button>
					</Form.Item>
				</div>
			);
		} else {
			return (
				<Descriptions.Item label="Comment">
					{collection?.comment}
				</Descriptions.Item>
			);
		}
	};

	return (
		<>
			<Skeleton loading={!collection}>
				{collection?.waybill && (
					<CollectionWaybillBarcodeComponent
						waybill={collection?.waybill}
					/>
				)}
				{collection?.waybill && collection.supplier && (
					<ShareContentBar collection={collection} />
				)}
				{collection?.waybill && collection.supplier && (
					<CollectionPodComponent collection={collection} />
				)}
				{(collection?.status === CollectionStatus.Completed || collection?.status === CollectionStatus.Delivered) && (
					<Descriptions title={'Proof of Delivery'} column={1}>
						<Descriptions.Item label="Recipient Name">
							{collection?.signeeFullName || 'Not provided'}
						</Descriptions.Item>
						<Descriptions.Item label="Collected Date">
							{collection?.pickupDateTime ? moment(collection.pickupDateTime).format('dddd, DD MMM yyyy') : 'Not provided'}
						</Descriptions.Item>
						<Descriptions.Item label="Delivered Date & Time">
							{collection?.deliveryDateTime ? moment(collection.deliveryDateTime).format('dddd, DD MMM yyyy HH:mm') : 'Not provided'}
						</Descriptions.Item>
					</Descriptions>
				)}
				<Descriptions title={'Waybill Details'} column={1}>
					<Descriptions.Item label="Requested By">{`${collection?.requester.name} ${collection?.requester.surname} (${collection?.requester.company?.companyName})`}</Descriptions.Item>
					<Descriptions.Item label="Service">
						{collection?.serviceType.displayName}
					</Descriptions.Item>
					<Descriptions.Item label="Ready Date & Time">
						{moment(collection?.readyDate).format('dddd, dd MMM yyyy')} ({collection?.readyTime.toString()} - {collection?.closingTime?.toString()})
					</Descriptions.Item>
			
					<Descriptions.Item label="Optional Insurance">
						{collection?.insurance ? 'Yes' : 'No'}
					</Descriptions.Item>
					{getCommentComponent()}
					<Descriptions.Item label="Client Identifier">
						{collection?.clientIdentifier}
					</Descriptions.Item>
					
				</Descriptions>

				<Descriptions title={'Waybill Charge'} column={1}>
					<Descriptions.Item label="Service">
						{collection?.serviceType.displayName}
					</Descriptions.Item>
					<Descriptions.Item label="Total VAT">
						{((collection?.myVat ?? 0) === 0
							? 'To Be Calculated'
							: collection?.myVat!
						).toLocaleString('en-ZA', {
							style: 'currency',
							currency: 'ZAR'
						})}
					</Descriptions.Item>
					<Descriptions.Item label="Total payable (incl VAT)">
						{(collection?.myRate ?? 0) === 0
							? 'To Be Calculated'
							: (
									(collection?.myRate ?? 0) +
									(collection?.myVat ?? 0)
							  ).toLocaleString('en-ZA', {
									style: 'currency',
									currency: 'ZAR'
							  })}
					</Descriptions.Item>
					<Descriptions.Item label="Chargeable mass">
						{(collection?.shipmentMass ?? 0) === 0
							? 'To Be Calculated'
							: collection?.shipmentMass}
					</Descriptions.Item>
					<Descriptions.Item label="Status">
						{CollectionStatus[collection?.status ?? 0]}
					</Descriptions.Item>
				</Descriptions>
			</Skeleton>
		</>
	);
};

export default CollectionWaybillDescriptionsComponent;
